export default "__VITE_ASSET__BRgJISrP__"